import { isNumber } from 'underscore';
import React, { useMemo, useContext } from 'react';
import PropTypes from 'prop-types';
import {
  makeStyles,
  mergeClasses,
  shorthands,
  tokens,
} from '@fluentui/react-components';
import { I18nContext } from '@bingads-webui-react/i18n-context';

const useOptionStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'row',
    flexGrow: 1,
    ...shorthands.gap('10px'),
  },
  optionText: {
    flexGrow: 1,
  },
  optionNumber: {
    flexShrink: 0,
    color: tokens.colorNeutralForegroundDisabled,
  },
});

export const OptionItem = ({ option: { text, number } }) => {
  const i18n = useContext(I18nContext);
  const classes = useOptionStyles();
  const optionNumber = useMemo(() => {
    if (!isNumber(number)) {
      return null;
    }
    if (number === 1) {
      return i18n.getString(_TL_('1 page URL'));
    }
    return i18n.getString(_TL_('{{number}} page URLs'), { number });
  }, [number, i18n]);

  return (
    <div className={mergeClasses('page-feed-selector-item', classes.root)}>
      <div className={mergeClasses('page-feed-selector-item-text', classes.optionText)}>{text}</div>
      {optionNumber && <div className={mergeClasses('page-feed-selector-item-number', classes.optionNumber)}>{optionNumber}</div>}
    </div>
  );
};

OptionItem.propTypes = {
  option: PropTypes.shape({
    text: PropTypes.string.isRequired,
    number: PropTypes.number.isRequired,
  }).isRequired,
};
